/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/dataMaintenanceContextBase.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.AppointmentCategories {
    "use strict";

    export class appointmentCategoriesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService;
        $q: angular.IQService;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            trackingService: Meevo.Components.Tracking.ITrackingService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.securityChecker = securityChecker;
           

            this.baseEndpoint = appSettings.API_ENDPOINTS.appointmentCategory;
            this.sectionTemplatePath = "app/plugins/appointmentCategories/sectionViews/";
            this.entityType = 'AppointmentCategory';
            this.buildCrudSecurityKeys(this.securityKeys.DATA_APPOINTMENTCATEGORY_TAB_MAIN);
            this.initializeSections();
        }

        initializeSections(): void {
         if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_APPOINTMENTCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                 this.sections.push(new MainSection(0, "SECTION_SERVICES_MAIN", "main.html", true, false, this.baseEndpoint, "",
                   this.loggingService, this.dataService, this.identityService, Model.NounEnum.AppointmentCategoryMain, null,
                   this.securityKeys.DATA_APPOINTMENTCATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
          }
        }

        initializeHeader(model: any): void {
            this.businessTypeDetail = model.businessTypeDetail;
            this.headerContent = model.displayName;

        }
    
        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.AppointmentCategory>();
            model.displayName = undefined;
        }

    }
}